import axios from "axios";
import CryptoJS from "crypto-js";
import forge from "node-forge";


// lsq lapp names for different cases
const lappNames = {
  OTP: "da_46725_9f5d7299",
  CREATE: "da_46725_c0ebcc55",
  MAVIS: "da_46725_b19b105f",
  CIBIL: "da_46725_2fb2df8c",
  CUSTOMER_SEARCH: "da_46725_a9bdc684",
  UPDATE_LEAD: "da_46725_89cae1b0",
  HIRECRAFT: "da_46725_1e8e839f",
};

// lsq base URL
const LSQ_BASE_URL =
  "https://f0jz2wbufc.execute-api.ap-south-1.amazonaws.com/default/lapp-proxy";

// call lsq api
export const callLSQLapp = async (payload, lappType, param) => {
  try {
    console.log("payload, lappType, param", { payload, lappType, param });
    // create payload
    let proxyPayload = {
      method: "post",
      orgId: "46725",
      params: {
        stage: "Live",
        name: lappNames[lappType],
      },
      data: {
        lappBody: payload,
      },
    };

    // add params
    if (param) {
      const mergedObject = Object.assign({}, proxyPayload.params, param);
      proxyPayload.params = mergedObject;
    }
    // console.log("proxyPayload", proxyPayload);
    const res = await axios.post(LSQ_BASE_URL, proxyPayload);
    return res;
  } catch (error) {
    console.log("callLSQLapp error", error);
  }
};


// / Helper function to generate a random numeric string of a given length
const generateRandomNumber = (length) => {
  return Array.from({ length }, () => Math.floor(Math.random() * 10)).join("");
};

// AES encryption function using crypto-js
const encryptData = (value, sessionKey, iv) => {
  const encrypted = CryptoJS.AES.encrypt(
    value,
    CryptoJS.enc.Utf8.parse(sessionKey),
    {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString();
};

// Main encryption function
export const encryptBody = async (payload) => {
  // Generate session key and IV
  const sessionKey = generateRandomNumber(16);
  const iv = generateRandomNumber(16);

  // Encrypt the session key with RSA using node-forge
  const publicKeyPem = process.env.REACT_APP_ICICI_PUBLIC_KEY;

  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
  const encryptedSessionKey = forge.util.encode64(
    publicKey.encrypt(sessionKey, "RSAES-PKCS1-V1_5")
  );

  // Prepare and encrypt the data payload
  const data = iv + JSON.stringify(payload);
  const encryptedData = encryptData(data, sessionKey, iv);

  // Construct the final encrypted response object
  return {
    requestId: "",
    service: "",
    encryptedKey: encryptedSessionKey,
    oaepHashingAlgorithm: "NONE",
    iv: "",
    encryptedData,
    clientInfo: "",
    optionalParam: "",
  };
};


export function getLsqLeadBody(formData) {
  let Config = {
       AdType: "SourceMedium",
    SearchEngine: "mx_Source_UTM",
    ModeOfLead: "Source",
    Income: "mx_Take_Home_Salary",
    FirstName: "FirstName",
    LastName: "LastName",
    email: "EmailAddress",
    mobile: "Mobile",
    pincode: "mx_Pincode",
    dob: "mx_Date_of_Birth",
    gstNumber: "mx_GST_Number",
    currentAccount: "mx_Current_Account",
    City: "mx_City",
    Occupation: "mx_Employment_Type",
    Gclid: "mx_Gclid",
    HighestEducationQual:"mx_HighestEducation_Qualification",
    CurrentFixedCTC:"mx_Current_Fixed_CTC",
    Referral: "mx_Referral",
    Relationship: "mx_Relationship",
    Keyword: "mx_Utm_Terms",
    utm_content: "mx_Ad_Group",
    utm_campaign: "mx_Campaign_Type",
    utm_lms: "mx_utm_lms",
    ModeofSal: "mx_Salary_Received_in_Cash",
    User_Agent: "mx_Lead_Device",
    consent: "DoNotTrack",
    TypeOfBusiness: "mx_Type_Of_Business",
    CompleteUrl: "mx_UTM_URL_Details",
    Campaign: "SourceCampaign",
    Adgroup: "SourceContent",
    Pl: "mx_Pl",
    audit: "mx_Audited_Finacials",
    // turnover: 'mx_Annual_Turnover',
    Product: "mx_Product",
    Pincode: "mx_Pincode",
    Obligation: "mx_Obligation_Amount",
    LoanAmount: "mx_Loan_Amount",
    LoanType: "mx_BT_Loan_Type",
    ExistingLender: "mx_BT_Existing_Lender",
    LoanTaken: "mx_BT_Loan_Taken_Year",
    Eligible: "mx_Eligible",
    // EntityName: 'mx_Entity_Name',
    // BusinessVintage: 'mx_Business_Vintage',
    CampaignId: "mx_Campaign_ID",
    mx_Zip: "mx_Zip",
    selectedItem: "mx_Current_Customer",
    percentage: "mx_Graduation_Percentage",
    gradStatus: "mx_Graduation",
    uniqueToken: "mx_Token",
    FBClickID: "mx_FB_Click_ID",
    FBPixelID: "mx_FB_Pixel_ID",
    hireCraftStatusCode: "mx_Hirecraft_Response_code",
    hireCraftResponseMessage: "mx_response_message",
    applicantID: "mx_Application_ID",
    isDedupe: "mx_DuplicateLead",
    organization: "mx_Company_name",
    TotalWorkExperience: "mx_Work_Experience",
    PreferredJobLocation: "mx_Preferred_Job_Location",
    IsInterviewedIBank: "mx_Interviewed_with_ICICI",
    WorkingInIBank: "mx_Working_in_ICICI_group_company",
    BloodRelatives: "mx_Blood_Relative_in_ICICI",
    PreferredInterviewDate: "mx_Preferred_Interview_Date",
    PreferredTimeSlot: "mx_Preferred_Time_Slot",
    UTM_Content: "mx_CTA",
    graduationType:"mx_graduation_type",
    tenthPercentage:"mx_10th_Percentage",
    iConsent: "mx_Iauthorization",
    overallWorkExperience: "mx_overall_work_experience",
    twelvePercentage: "mx_12th_Percentage",
    overallWorkExperienceYears: "mx_overall_work_experience",
    overallWorkExperienceMonths: "mx_Experience_in_Month",
    dataProcessConsent: "mx_Software_Name",
  };
  let LeadBody = [];
  Object.keys(Config).forEach((key) => {
    if (formData.hasOwnProperty(key) && formData[key])
      LeadBody.push({
        Attribute: Config[key],
        Value: formData[key],
      });
  });
  return LeadBody;
}